import { render, staticRenderFns } from "./apiConfig.vue?vue&type=template&id=678cede9&"
import script from "./apiConfig.vue?vue&type=script&lang=js&"
export * from "./apiConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports